/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryReviewItem,
  DirectoryReviewItem$inboundSchema,
} from "./directoryreviewitem.js";

export type ListDirectoryReviewItemsResult = {
  /**
   * Pending items, oldest first.
   */
  items: Array<DirectoryReviewItem>;
};

/** @internal */
export const ListDirectoryReviewItemsResult$inboundSchema: z.ZodMiniType<
  ListDirectoryReviewItemsResult,
  unknown
> = z.object({
  items: z.array(DirectoryReviewItem$inboundSchema),
});

export function listDirectoryReviewItemsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDirectoryReviewItemsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDirectoryReviewItemsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDirectoryReviewItemsResult' from JSON`,
  );
}
